const TEN_DIGIT_MEMBER_ACCOUNT_PATTERN = /^\d{10}$/;

export function maskMemberAccountForDisplay(memberAccount: string) {
  if (!TEN_DIGIT_MEMBER_ACCOUNT_PATTERN.test(memberAccount)) {
    return memberAccount;
  }

  return `${memberAccount.slice(0, 6)}***${memberAccount.slice(-1)}`;
}
